<select class="input minimal" (change)="addIsAdminFilter($event)" [value]="SelectedIsAdmin">
    <option value="false" style="color:gray">Admin Roles</option>
    <option value="true" style="color:gray">End User Roles</option>
</select>